import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Accordion, AccordionDetails, AccordionSummary, Grid, Link, Paper, Typography } from "@mui/material";
import React from "react";
import { Link as LinkRouter } from "react-router-dom";

const SupportPage = () => {    
    return (
        <Grid display="flex" flexDirection="column" flexGrow="1" overflow="auto">
            <Grid
                className="vocalysed-home-upadted profile"
                container
                spacing={0}
                direction="column"
                flexWrap="nowrap"
                flexGrow={1}
                paddingTop={2}
                paddingX={3}
                paddingBottom={3}
                overflow="auto"
                gap={3}
            >
                <Paper
                    sx={{display: "flex", flexDirection: "column", flexGrow: 1, width: '100%', borderRadius: 2.5, padding: 3, boxSizing: "border-box" }}
                >
                    <Typography variant="h5" component="div" fontWeight={600} gutterBottom>
                        Support - Vocalysd.ai
                    </Typography>
                    <Typography variant="body1" paragraph>
                        Vocalysd’s AI-driven platform converts conversational data into targeted insights that enhance customer satisfaction and operational efficiency. By automating the analysis of customer communications, we enable businesses to build stronger relationships with customers, support compliance, and enhance performance monitoring, ultimately fostering a customer-centric culture.
                    </Typography>

                    <Typography variant="h5" component="div" fontWeight={600} gutterBottom>
                        Frequently Asked Questions
                    </Typography>
                    <Accordion>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                            <Typography fontWeight={500}>How do I get started with Vocalysd.ai?</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Typography>
                                Getting started is simple! Sign up for an account, upload your conversational data, and let our AI provide insights that improve your customer interactions.
                            </Typography>
                        </AccordionDetails>
                    </Accordion>

                    <Accordion>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                            <Typography fontWeight={500}>What kind of insights can I get from Vocalysd.ai?</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Typography>
                                Our platform provides insights into customer sentiment, compliance adherence, agent performance, and other key conversational metrics.
                            </Typography>
                        </AccordionDetails>
                    </Accordion>

                    <Typography variant="h5" component="div" fontWeight={600} gutterBottom sx={{ mt: 3 }}>
                        Need More Help?
                    </Typography>
                    <Typography variant="body1" paragraph>
                        If you need further assistance, feel free to reach out to our support team.
                        <br />
                        <Link as={LinkRouter} underline="always" color="inherit" to="mailto:support@vocalysd.ai">support@vocalysd.ai</Link>
                    </Typography>
                    
                </Paper>
            </Grid>

        </Grid>
    );
};

export default SupportPage;